// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__Dslkm","choiceBoxes":"toolbarselects_choiceBoxes__3aCWA","simpleField":"toolbarselects_simpleField__1XGwb"};